export default {
  inform: {
    profile: {
      text: 'Нажмите кнопку "Разблокировать"',
      title: 'Приложение заблокировано',
    },
  },
}
